export default "__VITE_ASSET__Ce$bKmZr__"